<script lang="ts">
  import CloudflareImage from './CloudflareImage.svelte';
  import UnpublishedAlert from './UnpublishedAlert.svelte';
  import { slugify } from '$lib/utils';
    import type { auctions } from '@prisma/client';

  type Auction = Pick<auctions, 'id' | 'uid' | 'title' | 'image' | 'published'>;
  export let auction: Auction;
</script>

<div
  data-testid={`auction:${auction.id}`}
  class="flex flex-1 flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center"
>
  <div class="flex-auto lg:col-span-7 xl:col-span-8 md:px-8">
    <div class="aspect-w-5 aspect-h-2 rounded-lg bg-gray-100 overflow-hidden">
      <CloudflareImage src={auction.image} alt={auction.title} class="object-center object-cover" />
    </div>
  </div>
  <div class="mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4 md:px-8">
    {#if !auction.published}<UnpublishedAlert />{/if}
    <h3 class="text-lg font-medium text-gray-900 mb-4">
      {auction.title}
    </h3>
    <a
      href={`/subastas/${slugify(auction.title)}/${auction.uid}`}
      class="
        w-full justify-center py-2 border border-transparent rounded-md shadow-sm text-sm
        font-medium text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:ring-2
        focus:ring-offset-2 focus:ring-primary-500 mt-4 inline-flex items-center px-3 leading-4
      "
    >
      Leer más
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="ml-2 -mr-0.5 h-6 w-6"
      >
        <path
          fill-rule="evenodd"
          d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
          clip-rule="evenodd"
        />
      </svg>
    </a>
  </div>
</div>
